import { googleRef } from 'external-libs/googleMaps';
import { isPresent } from 'utils/isPresent';

export default class HCMapModel {
  constructor() {
    this.markers = [];
    this.directions = [];
    this.circles = [];

    this.directionsService = googleRef.maps ? new googleRef.maps.DirectionsService() : {};
  }

  clearMarkers() {
    this.markers.map((marker) => {
      if (isPresent(marker) && isPresent(marker.getMap())) {
        marker.setMap(null);
      }
    });

    this.markers = [];
  }

  addMarkerListener(map, marker, markerInfo) {
    if (isPresent(markerInfo.labelContent)) {
      let infoWindow = new googleRef.maps.InfoWindow({ content: markerInfo.labelContent });

      googleRef.maps.event.addListener(marker, 'click', function (e) {
        infoWindow.open(map, this);
      });
    }
  }

  updateMarkers(markerInfos, map) {
    this.clearMarkers();

    if (isPresent(markerInfos) && isPresent(map)) {
      this.markers = markerInfos.map((markerInfo) => {
        let marker = new googleRef.maps.Marker(markerInfo);
        marker.setMap(map);

        this.addMarkerListener(map, marker, markerInfo);
        return marker;
      });
    }
  }

  clearDirections() {
    this.directions.map((direction) => {
      if (isPresent(direction) && isPresent(direction.getMap())) {
        direction.setMap(null);
      }
    });

    this.directions = [];
  }

  updateDirections(directionInfos, map) {
    this.clearDirections();

    if (isPresent(directionInfos) && isPresent(map)) {
      this.directions = directionInfos.map((directionInfo) => {
        let direction = new googleRef.maps.DirectionsRenderer({
          suppressMarkers: true,
          suppressInfoWindows: true,
          polylineOptions: {
            strokeColor: directionInfo.colorHex,
          },
        });
        direction.setMap(map);

        let request = {
          origin: directionInfo.origin,
          destination: directionInfo.destination,
          travelMode: googleRef.maps.DirectionsTravelMode.DRIVING,
        };

        this.directionsService.route(request, (response, status) => {
          if (status === googleRef.maps.DirectionsStatus.OK) {
            direction.setDirections(response);
          } else {
            console.log('wrong route! says the GOOGLE MAP!: ', status);
            console.log('given origin:', directionInfo.origin);
            console.log('given destination: ', directionInfo.destination);
          }
        });

        return direction;
      });
    }
  }

  clearCircles() {
    this.circles.map((circle) => {
      if (isPresent(circle) && isPresent(circle.getMap())) {
        circle.setMap(null);
      }
    });

    this.circles = [];
  }

  updateCircle(circleInfos, map) {
    this.clearCircles();

    if (isPresent(circleInfos) && isPresent(map)) {
      this.circles = circleInfos.map((circleInfo) => {
        let circle = new googleRef.maps.Circle(circleInfo);
        circle.setMap(map);

        return circle;
      });
    }
  }
}
